import React, {FC} from 'react';

import {AccountsJobModel} from '../../../../models/api/jobModel';
import {AccountsCSVImportBannerContainer} from './accountsCSVImportBannerContainer';

/*
 * Props.
 */

interface AccountsCSVImportBannersProps {
  accountImportJobs: ReadonlyArray<AccountsJobModel>;
}

/*
 * Component.
 */

export const AccountsCSVImportBanners: FC<AccountsCSVImportBannersProps> = ({accountImportJobs}) => (
  <>
    {accountImportJobs.map((job) => (
      <AccountsCSVImportBannerContainer key={job.id} job={job} />
    ))}
  </>
);
